import { InventoryLogItemDto } from '@entities/equipmentInventory';

const isInventoryLogItemDto = (value: unknown): value is InventoryLogItemDto =>
    Boolean(
        value &&
            typeof value === 'object' &&
            'guid' in value &&
            'datetime' in value &&
            'text' in value
    );

export const getInventoryLogFromResponse = (response: unknown): InventoryLogItemDto | null => {
    if (isInventoryLogItemDto(response)) {
        return response;
    }

    if (!response || typeof response !== 'object' || !('logItem' in response)) {
        return null;
    }

    const { logItem } = response as { logItem?: unknown };

    return isInventoryLogItemDto(logItem) ? logItem : null;
};
